import { Extension, KeyboardShortcutCommand } from '@tiptap/core'
import { addAttendeeUnderLabel, createAttendeeStructurePlugin, isAttendeeListSelected, removeEmptyAttendeeEntry } from './attendee-structure-plugin'
import { TRACK_CHANGES_PRIORITY } from './track-changes-extension'

export const AttendeeStructureExtension = Extension.create({
  name: 'attendeeStructure',

  // Ahead of the list extensions, and of `TrackChangesExtension`, which claims Backspace too — derived from
  // its priority so a bump there cannot silently lose the race.
  priority: TRACK_CHANGES_PRIORITY + 1,

  addProseMirrorPlugins() {
    return [createAttendeeStructurePlugin()]
  },

  /**
   * The list-type shortcuts are swallowed outright. The plugin would reject what they produce anyway, but
   * `attendee_list` holds `paragraph bulletList*`, so on a group label the command throws building a numbered
   * list rather than returning false. The fix that would cover every caller is for the shared commands in
   * `backend/src/tiptap/editor/extensions/nodes/list.ts` to check the parent can host the type they wrap in.
   */
  addKeyboardShortcuts() {
    const swallowInAttendeeList: KeyboardShortcutCommand = ({ editor }) => isAttendeeListSelected(editor.state)

    return {
      'Mod-Shift-7': swallowInAttendeeList,
      'Mod-Shift-8': swallowInAttendeeList,
      Enter: ({ editor }) => editor.commands.command(addAttendeeUnderLabel),
      Backspace: ({ editor }) => editor.commands.command(removeEmptyAttendeeEntry),
    }
  },
})
